<wms-dialog-header (onClose)="appLocaleService.closeModal()" title='{{locale.LABEL_APP_MESSAGES_DIALOG_TITLE}}'
    helpTitle="{{locale.LABEL_APP_MESSAGES}}"
    helpLink="https://www.wavemaker.com/learn/app-development/widgets/form-widgets/select-locale/"></wms-dialog-header>
<wms-dialog-body>
    <div class="primary-panel locale-content full-width">
        <datalist id="locale-settings-date-patterns-list">
            <option *ngFor="let opt of datePatterns">{{opt}}</option>
        </datalist>
        <datalist id="locale-settings-time-patterns-list">
            <option *ngFor="let opt of timePatterns">{{opt}}</option>
        </datalist>
        <datalist id="locale-settings-currency-patterns-list">
            <option *ngFor="let opt of currencyOptions">{{opt}}</option>
        </datalist>
        <wms-message [scopeDataset]="appLocaleService.validationMessage"></wms-message>
        <div class="message-container full-height">
            <div *ngIf="!appLocaleService.addInProgress" class="wm-search-container">
                <div class="localization-search pull-right">
                    <wms-search id="localization-search" width="18em" [hidden]="activeTabIndex === 1"
                        placeholder="{{locale.LABEL_SEARCH + ' ' +locale.LABEL_APP_MESSAGE_KEY + '...'}}"
                        (onSearch)="searchMessages($event)"></wms-search>
                </div>
            </div>
            <tabset class="message-tabs">
                <tab name="wm-locale-messages" (selectTab)="setActiveTab(0)" [active]="activeTabIndex === 0">
                    <ng-template tabHeading class="tab-heading">
                        <span class="studio-tab-labels messages-label">{{locale.LABEL_MESSAGES}}</span>
                    </ng-template>
                    <div class="tabs-btn col-xs-12" *ngIf="!appLocaleService.addInProgress">
                        <div class="col-xs-3">
                            <div class="btn-group">
                                <button type="button" class="radioBtn" [ngClass]="{'active': !appLocaleService.selectedPrefab}"
                                    (click)="showMessages('app')">{{locale.LABEL_APPLICATION}}</button>
                                <div class="button-2" dropdown #dropdown="bs-dropdown" [insideClick]="true">
                                    <button dropdownToggle type="button" [ngClass]="{'active': appLocaleService.selectedPrefab}" class="radioBtn dropdown-toggle">
                                        {{locale.LABEL_PREFABS}} <span class="caret"></span>
                                    </button>
                                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                                        <wms-search (onSearch)="targetSearch($event)"></wms-search>
                                        <div class="prefabsTab-list">
                                            <!-- Display a message if there are no prefabs to display -->
                                            <li *ngIf="appPrefabs.length === 0" class="no-items-message">
                                                {{locale.LABEL_EMPTY_PREFAB_LIST_SCREEN}}
                                            </li>
                                            <ng-container *ngFor="let target of appPrefabs | filter: 'name':targetSearchKey | orderBy: 'name'">
                                                <li role="menuitem" (click)="showMessages('prefab',target.name); dropdown.hide()">
                                                    <div class="item"
                                                        [title]="projectService.projectEdnDetails.branchType === 'BRANCH' ? target.name + ' (' + appLocaleService.projectDetails.vcsBranch + ')' : target.name">
                                                        <span class="title">{{target.name}}
                                                            <span *ngIf="projectService.projectEdnDetails.branchType === 'BRANCH'"> {{' (' +
                                                               appLocaleService.projectDetails.vcsBranch+') '}} </span>
                                                        </span>
                                                    </div>
                                                </li>
                                            </ng-container>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-5">
                            <p *ngIf="appLocaleService.selectedPrefab" class="selected-prefab">{{locale.LABEL_SELECTED_PREFAB}} : {{appLocaleService.selectedPrefab}}</p>
                        </div>
                        <div class="col-xs-4">
                            <button name="wm-add-new-locale" class="btn btn-default button-primary add-language-btn pull-right"
                                (click)="addLanguage();"
                                *wmsFeature="preferences.project.i18n.configure">{{locale.LABEL_I18N_MANAGE_LANGUAGES_BUTTON}}
                            </button>
                        </div>
                    </div>
                    <wms-locale-messages-tab [filteredMessagesList]="appLocaleService.filteredMessageList" [filteredPrefabMessagesList]="appLocaleService.filteredPrefabMessagesList" [selectedPrefab]="appLocaleService.selectedPrefab" (onTempLocaleChange)="tempLocaleChanged()"></wms-locale-messages-tab>
                </tab>
                <tab name="wm-locale-formats" (selectTab)="setActiveTab(1)" [active]="activeTabIndex === 1"
                    *ngIf="isApplicationType && !appLocaleService.addInProgress">
                    <ng-template tabHeading class="tab-heading">
                        <span class="studio-tab-labels formats-label">Formats</span>
                    </ng-template>
                    <wms-locale-formats-tab></wms-locale-formats-tab>
                </tab>
            </tabset>
        </div>
    </div>
</wms-dialog-body>
<wms-dialog-footer>
    <button (click)="appLocaleService.closeModal()" class="btn app-button button-secondary" name="wm-app-message-cancel"
        title="{{locale.LABEL_CANCEL}}">{{appLocaleService.addInProgress ? locale.LABEL_BACK :
        locale.LABEL_CANCEL}}</button>
    <button (click)="appLocaleService.save(false)" class="btn app-button button-primary" name="wm-app-message-save"
        title="{{locale.LABEL_SAVE}}">{{appLocaleService.addInProgress ?
        locale.LABEL_DONE : locale.LABEL_SAVE}}</button>
</wms-dialog-footer>
<wms-dialog id="addLocaleDialog" [content]="addLocaleContent"
    customClasses="app-messages-dialog small wm-studio-dialog locale-panel">
</wms-dialog>
<ng-template #addLocaleContent>
    <wms-add-locale-dialog (onModalClose)="closeDialogWithId('addLocaleDialog')"
        (onAddLocaleSave)="onLocaleDialogSave($event)"></wms-add-locale-dialog>
</ng-template>
